export default __webpack_public_path__ + "static/media/flag-rs.c9380798.svg";